import { render, staticRenderFns } from "./Cuisine.vue?vue&type=template&id=5b7f5f12"
import script from "./Cuisine.vue?vue&type=script&lang=js"
export * from "./Cuisine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports